import { render, staticRenderFns } from "./ChatGameUser.vue?vue&type=template&id=73fd7090&"
import script from "./ChatGameUser.vue?vue&type=script&lang=js&"
export * from "./ChatGameUser.vue?vue&type=script&lang=js&"
import style0 from "./ChatGameUser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports